import { ChangeDetectionStrategy, Component, computed, input, Signal } from '@angular/core';
import { Icons } from '../../models/icons.model';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

type InfoBlockTheme = 'gray';

interface InfoBlockConfig {
  bg: string;
  icon: string;
  text: string;
}

const themeMapping: { [key in InfoBlockTheme]: InfoBlockConfig } = {
  gray: {
    bg: 'bg-gray-100',
    icon: 'text-gray-700',
    text: 'text-gray-800',
  },
};

@Component({
  selector: 'csl-info-block',
  standalone: true,
  imports: [SvgIconComponent],
  template: ` <div class="flex items-start gap-2 rounded-2xl {{ themeConfig().bg }} p-4" data-testid="csl-info-root">
    <csl-svg-icon [name]="icon()" class="size-6 {{ themeConfig().icon }}"></csl-svg-icon>
    <div class="text-base font-normal {{ themeConfig().text }}" data-testid="csl-info-label">{{ text() }}</div>
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CslInfoBlockComponent {
  public text = input.required<string>();
  public theme = input<InfoBlockTheme>('gray');
  public icon = input<Icons>(Icons.Info);

  public readonly themeConfig: Signal<InfoBlockConfig> = computed(() => themeMapping[this.theme()]);
}
